<style scoped lang="scss">
    .uk-block-primary {
        background-color: #dfeaff;

        .title {
            font-size: 2.0em;
        }

        .owner-information {
            .organization-name {
                font-size: 1.0em;
                text-transform: uppercase;
                margin-bottom: 4px;
            }

            .person-name {
                font-size: 1.4em;
                margin-bottom: 8px;
            }

            .person-address {
                font-size: 1.2em;
            }
        }
    }
</style>

<template>
    <div>
        <div class="uk-grid uk-block uk-block-primary">
            <div class="uk-width-medium-4-5 uk-margin-bottom">
                <div class="title uk-margin-small-bottom">{{ roleName }}</div>
                <a v-if="allowChange" href="javascript:;" @click="showSearch = !showSearch">Change {{ roleName }}</a>
            </div>
            <div class="uk-width-medium-4-5 uk-margin-bottom" v-if="showSearch">
                <p v-if="renterManager && renterManager.first_name">
                    {{ programSettings['landlord-change-search-text'] }}
                </p>
                <p v-else>
                    {{ programSettings['landlord-new-search-text'] }}
                </p>
                <autocomplete
                        :placeholder="'Find My '+roleName + '...'"
                        ref="autocomplete"
                        class="form-autocomplete"
                        :search="search"
                        :debounce-time="200"
                        :get-result-value="getResultValue"
                        @submit="setPerson"
                >
                    <template #result="{ result, props }">
                        <li v-bind="props">
                            <div v-if="result.project_id">
                                <p>Property: {{ result.project_name }}</p>
                                <p v-if="programSettings['show-property-owner-information-to-tenants']">Owned By: <span v-if="result.property_owner_organization_vendor_id">{{ result.property_owner_organization_vendor_id }}</span> {{ result.property_owner_organization_name }}</p>
                                <p>Managed By: <span v-if="result.property_manager_organization_vendor_id">{{ result.property_manager_organization_vendor_id }}</span> {{ result.property_manager_organization_name }}</p>
                                <p>Contact: {{ result.property_manager_first_name }} {{ result.property_manager_last_name }}</p>
                            </div>
                            <div v-else>
                                Add {{ roleName }}
                            </div>
                        </li>
                    </template>
                </autocomplete>
            </div>
            <div class="uk-width-medium-1-1" v-if="!isCustomPerson">
                <div class="owner-information">
                    <div class="project-name" v-if="project"><i class="a-buildings-2"></i> {{ project.project_name }}</div>
                    <div class="organization-name"><i class="a-person-home"></i> {{ person.company_name }}</div>
                    <div class="person-name" v-if="person.first_name"><i class="a-avatar"></i> {{ person.first_name }} {{ person.last_name }}</div>

                </div>
            </div>

        </div>
        <create-property-contact-modal ref="createContact"
                                       :application-role-id="applicationRoleId"
                                       :table="table"
                                       :prefix="table === 'household_applications' ? 'landlord' : 'owner'"
                                       @done="onDone"></create-property-contact-modal>
    </div>
</template>

<script>

    import Autocomplete from '@trevoreyre/autocomplete-vue';
    import {mapState} from "vuex";
    import ValidatedSection from "../../Common/ValidatedSection";
    import CreatePropertyContactModal from "./CreatePropertyContactModal";
    export default {
        name: "PropertyContactForm",
        props: {
            person: {
                type: Object,
                required: true,
            },
            applicationRoleId: {
                type: Number,
                default: 3,
            },
            additionalRoleId: {
                type: Number,
                default: null,
            },
            table: {
                type: String,
                required: true,
            },
            allowChange: {
                type: Boolean,
                default: true
            }
        },
        components: {CreatePropertyContactModal, ValidatedSection, Autocomplete},
        data() {
            return {
                showSearch: false,
                submitData: {},
                serverValidationErrors: {},
                landlord: null,
                changeOwner: false,
            }
        },
        computed: {
            roleName() {
                if(this.applicationRoleId === 3) {
                    return 'Landlord';
                }
                if(this.applicationRoleId === 4) {
                    return 'Property Owner';
                }
                if(this.applicationRoleId === 5) {
                    return 'Mortgage Servicer';
                }
                return '';
            },
            isApplication() {
                return this.table === 'household_applications';
            },
            ...mapState('Application', {
                applicationId: state => state.application.id,
                application: state => state.application,
                project: state => state.project,
                programSettings: state => state.application.program.settings,
                assets: state => state.assets,
            }),
            ...mapState('Landlord', {
                confirmation: state => state.confirmation,
            })
        },
        watch: {
            person(newValue) {
                if(!newValue || !newValue.person_id) {
                    this.showSearch = true;
                }else {
                    this.showSearch = false;
                }
            }
        },
        mounted() {
            if(!this.person || !this.person.person_id) {
                this.showSearch = true;
            }
            if(!this.renterManager) {
                this.showSearch = true;
            }
        },
        methods: {

            getResultValue(result) {
                let stringParts = [result.first_name + ' ' + result.last_name];
                if(result.email) {
                    stringParts.push(result.email.email_address);
                }
                return stringParts.join(' | ')
            },
            async search(queryString) {
                if(queryString.length < 3) return [];
                let url = '/api/hope/applications/'+this.applicationId+'/find-landlord';
                if(!this.isApplication) {
                    url = '/api/landlord/find-owner';
                }
                let r = await axios.get(url + '?query='+queryString)
                r.data.push({
                    organization_id: null,
                    first_name: 'Add New',
                    last_name: 'Contact',
                })
                return r.data;
            },

            timeout(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            },
            async setPerson(result) {
                console.log('Adding Person', result)

                this.$emit('beforeSubmit');

                await this.timeout(500);

                this.$refs.autocomplete.value = '';

                if(result.property_manager_organization_id == null) {
                    this.$refs.createContact.open();
                    return;
                }

                let url = `/api/hope/applications/${this.applicationId}/set-contact`;
                if(!this.isApplication) {
                    url = `/api/landlord/${this.confirmation.id}/set-contact`;
                }

                axios.post(url, {
                    person_id: result.person_id,
                    application_role_id: this.applicationRoleId,
                    additional_role_id: this.additionalRoleId,
                    organization_id: result.organization_id,
                    result: result,
                }).then(async r => {
                    if(this.isApplication) {
                        await this.$store.dispatch('Application/fetch', this.applicationId);
                    }else {
                        axios.get('/api/landlord/'+this.confirmation.id).then(r => {
                            this.$store.dispatch('App/setUser', { user: r.data.user })
                            this.$store.commit('Application/fetchSuccess', r.data.application)
                            this.$store.commit('Landlord/setConfirmation', r.data.confirmation);
                            this.$store.commit('Landlord/setDocuments', r.data.documents);
                            this.$isLoading(false);
                        });
                    }
                    this.$emit('updateLL', {type: 'existing'});
                    this.changeOwner = false;
                })
            },

            async onDone(result) {
                if(this.isApplication) {
                    await this.$store.dispatch('Application/fetch', this.applicationId);
                }else {
                    axios.get('/api/landlord/'+this.confirmation.id).then(r => {
                        this.$store.dispatch('App/setUser', { user: r.data.user })
                        this.$store.commit('Application/fetchSuccess', r.data.application)
                        this.$store.commit('Landlord/setConfirmation', r.data.confirmation);
                        this.$store.commit('Landlord/setDocuments', r.data.documents);
                        this.$isLoading(false);
                    });
                }
                this.$emit('updateLL', {type: 'new'});
                this.changeOwner = false;
            },

            editCustomContact(contact) {
                // TODO: Open edit contact modal
                this.$refs.createContact.openEdit(contact);
            }
        }
    }
</script>
